import MRitualEnrollList from './MRitualEnrollList.vue';

export { MRitualEnrollList };
export default MRitualEnrollList;
